import { IDeleteGrupoAcessoUseCase } from "../../../presentation/useCases/delete/delete_access_group_use_case";
import { IAdministracaoRepository } from "../../repositories/administracao_repository";

/**
 * DeleteGrupoAcessoUseCase
 */

export class DeleteGrupoAcessoUseCase implements IDeleteGrupoAcessoUseCase {
  constructor(
    private readonly repository: IAdministracaoRepository,
  ) { }

  async execute(idGrupoAcesso: number): Promise<void> {
    await this.repository.deleteGrupoAcesso(idGrupoAcesso);

  }
}